import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { translations, loadLocale } from '../i18n/translations';
import { getLanguage } from '../i18n/languages';
import api from '../lib/api';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('app_language') || 'en');
  const [version, setVersion] = useState(0);

  const applyDir = useCallback((code) => {
    const meta = getLanguage(code);
    document.documentElement.setAttribute('dir', meta.dir);
    document.documentElement.setAttribute('lang', code);
    document.body.style.fontFamily = meta.font;
  }, []);

  useEffect(() => {
    applyDir(lang);
    if (!translations[lang]) {
      loadLocale(lang).then((d) => { if (d) setVersion((v) => v + 1); });
    }
  }, [lang, applyDir]);

  const changeLanguage = useCallback(async (code, persist = false) => {
    await loadLocale(code);
    setLang(code);
    localStorage.setItem('app_language', code);
    if (persist && localStorage.getItem('session_token')) {
      try { await api.put('/auth/language', { preferred_language: code }); } catch (e) { console.error('Failed to persist language:', e); }
    }
  }, []);

  const t = useCallback((key) => {
    const dict = translations[lang] || {};
    return dict[key] || translations.en[key] || key;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, version]);

  const meta = getLanguage(lang);

  return (
    <LanguageContext.Provider value={{ lang, changeLanguage, t, dir: meta.dir }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
